<template>
    <div class="home">
        <banner isHome="true"></banner>
        <div class="site-content animate">
            <!--通知栏-->
            <div class="notify">
                <div class="search-result" v-if="hideSlogan">
                    <span v-if="searchWords">搜索结果："{{searchWords}}" 相关文章</span>
                    <span v-else-if="category">分类 "{{category}}" 相关文章</span>
                </div>
                <quote v-else>{{notice}}</quote>
            </div>

            <!--焦点图-->
            <div class="top-feature" v-if="!hideSlogan">
                <section-title v-if="!fetchIsNull">
                    <div style="display: flex;align-items: flex-end;">聚焦<small-ico></small-ico></div>
                </section-title>
                <div class="feature-content">
                    <div class="feature-item" v-for="item in features" :key="item.title">
                        <Feature :data="item"></Feature>
                    </div>
                </div>
            </div>
            <!--文章列表-->
            <main class="site-main" :class="{'search':hideSlogan}">
                <section-title v-if="!hideSlogan">推荐</section-title>
                  <post v-for="(item, index) in articleList" :post="item" :key="index"></post>
            </main>

            <!--加载更多-->
            <div class="more" v-show="hasNextPage">
                <div class="more-btn" @click="getList">加载更多</div>
            </div>
        </div>
    </div>
</template>

<script>
    import Banner from '@/components/banner'
    import Feature from '@/components/feature'
    import sectionTitle from '@/components/section-title'
    import Post from '@/components/post'
    import SmallIco from '@/components/small-ico'
    import Quote from '@/components/quote'
    import {getHomeInitData, queryArticleList} from '@/api'

    export default {
        name: 'Home',
        props: ['cate', 'words'],
        data() {
            return {
              features: [],
              articleList: [],
              currPage: 1,
              pageSize: 10,
              hasNextPage: true,
              fetchIsNull: false,
            }
        },
        components: {
            Banner,
            Feature,
            sectionTitle,
            Post,
            SmallIco,
            Quote
        },
        computed: {
            searchWords() {
                return this.$route.params.words
            },
            category() {
                return this.$route.params.cate
            },
            hideSlogan() {
                return this.category || this.searchWords
            },
            notice() {
                return this.$store.getters.notice
            }
        },
        methods: {
          // 获取首页初始化数据（整合接口）
          async fetchHomeInitData() {
              try {
                  const res = await getHomeInitData()
                  const data = res.data
                  
                  // 设置焦点图
                  if (data.focusArticles && data.focusArticles.length > 0) {
                      this.features = data.focusArticles
                  } else {
                      this.fetchIsNull = true
                  }
                  
                  // 将系统信息存储到 vuex（供其他组件使用）
                  if (data.systemInfo) {
                      this.$store.commit('SET_SYSTEM_INFO', data.systemInfo)
                      // 同时更新 websiteInfo 以兼容现有代码
                      this.$store.commit('SET_SITE_INFO', data.systemInfo)
                  }
                  
                  // 将系统图标存储到 vuex（供 socials 使用）
                  if (data.systemIcons) {
                      this.$store.commit('SET_SYSTEM_ICONS', data.systemIcons)
                      this.$store.commit('SET_SOCIALS', data.systemIcons)
                  }
                  
                  // 将文章分类存储到 vuex（供分类页面使用）
                  if (data.articleTypes) {
                      this.$store.commit('SET_ARTICLE_TYPES', data.articleTypes)
                  }
                  
                  // 保存到 localStorage，以便刷新页面后恢复数据
                  const storedData = {
                      systemInfo: data.systemInfo,
                      websiteInfo: data.systemInfo,
                      systemIcons: data.systemIcons,
                      articleTypes: data.articleTypes,
                      socials: data.systemIcons
                  }
                  localStorage.setItem('blog_init_data', JSON.stringify(storedData))
              } catch (error) {
                  console.error('获取首页数据失败:', error)
                  this.fetchIsNull = true
              }
          },
          async getList() {
            //请求页面数据
            const res = await queryArticleList(this.currPage, this.pageSize);
            if(res != null && res.data != null && res.data.length !== 0){
              ++this.currPage;
              const list = res.data;
              for(let i=0;i<list.length;i++){
                this.articleList.push(list[i])
              }
              if(res.data.length !== this.pageSize){
                this.hasNextPage = false;
              }
            }else {
              this.hasNextPage = false;
            }
          }
        },
        mounted() {
          this.getList();
          this.fetchHomeInitData(); // 使用整合接口替代原来的两个接口
        }
    }
</script>
<style scoped lang="less">

    .site-content {
        .notify {
            margin: 60px 0;
            border-radius: 3px;
            & > div {
                padding: 20px;
            }
        }


        .search-result {
            padding: 15px 20px;
            text-align: center;
            font-size: 20px;
            font-weight: 400;
            border: 1px dashed #ddd;
            color: #828282;
        }
    }

    .top-feature {
        width: 100%;
        height: auto;
        margin-top: 30px;

        .feature-content {
            margin-top: 10px;
            display: flex;
            justify-content: space-between;
            position: relative;

            .feature-item {
                width: 32.9%;
            }
        }
    }

    .site-main {
        padding-top: 80px;

        &.search {
            padding-top: 0;
        }
    }

    .more{
        margin: 50px 0;
        .more-btn{
            width: 100px;
            height: 40px;
            line-height: 40px;
            text-align: center;
            color: #ADADAD;
            border: 1px solid #ADADAD;
            border-radius: 20px;
            margin: 0 auto;
            cursor: pointer;
            &:hover{
                color: #8fd0cc;
                border: 1px dashed #8fd0cc;
            }
        }
    }

    /******/
    @media (max-width: 800px) {
        .top-feature {
            display: none;
        }

        .site-main {
            padding-top: 40px;
        }

        .site-content {
            .notify {
                margin: 30px 0 0 0;
            }

            .search-result {
                margin-bottom: 20px;
                font-size: 16px;
            }
        }
    }

    /******/
</style>
